export abstract class AbstractScriptLoader {
  abstract name: string;

  abstract isLoaded(): boolean;

  abstract load(trackingId?: string): Promise<boolean>;

  abstract init(initNeeded: boolean, trackingId?: string): Promise<boolean>;
}
